import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    receipt: 'Receipt',
    removeReceipt: 'Delete',
    seeReceipt: 'Show',
  },
  fr: {
    receipt: 'Justificatif',
    removeReceipt: 'Supprimer',
    seeReceipt: 'Voir',
  },
} as const);

export default locales;
